<template>
  <div>
    <el-card class="box-card brand-combine-year-container" ref="card">
      <div slot="header" class="clearfix" style="display: flex;align-items: center;justify-content: space-between;">
        <div>
          <b style="margin-right: 20px;">品牌集团年度维度</b>
          <el-date-picker
              v-model="date_s" value-format="yyyy"
              type="year" size="mini" style="width: 110px;" :clearable="false"/>
          对比
          <el-date-picker
              v-model="date_e" value-format="yyyy"
              type="year" size="mini" style="width: 110px;" :clearable="false"/>
        </div>
        <div>
          <el-link :underline="false" type="info" @click="handelEx">
            <i class="el-icon-download" style="font-size: 1.5rem;color: rgb(255, 90, 145);"/>
          </el-link>
          <el-link style="padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                   title="点击刷新" @click="getData">
            <i class="el-icon-refresh-right"/>
          </el-link>
        </div>
      </div>
      <el-table class="dashboard-table"
                id="brand-combine-year"
                show-summary
                :summary-method="getSummaries"
                :data="data"
                :row-style="{ border: 'none',padding:'15px 0'}"
                :cell-style="{ border: 'none'}"
                style="width: 100%" v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading">
        <el-table-column prop="combine_name" label="品牌集团" align="center">
          <template slot-scope="{row}">
            <el-link type="primary" @click="getBrands(row)">{{ row.combine_name || '' }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="money_before" align="center" :label="`${date_s_label}投放金额/万`">
          <template v-slot="{row}">
            <el-link v-if="row.money_before > 0" type="primary" @click="getBrandsItem(row, date_s)"><span class="money">{{ row.money_before|numberFormatW }}</span></el-link>
            <span v-else class="money">{{ row.money_before|numberFormatW }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="money_after" align="center" :label="`${date_e_label}投放金额/万`">
          <template v-slot="{row}">
            <el-link v-if="row.money_after > 0" type="primary" @click="getBrandsItem(row, date_e)"><span class="money">{{ row.money_after|numberFormatW }}</span></el-link>
            <span v-else class="money">{{ row.money_after|numberFormatW }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投放同比" align="center">
          <template v-slot="{row:{percent}}">
            <span>{{ percent !== null ? percent + ' %' : '/' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="direction" size="50%" :modal="false" append-to-body>
      <template slot="title">
        <span style="font-size: 18px;font-weight: bold">{{drawerTitle}}</span>
      </template>
      <div class="default-table" style="padding: 10px">
        <el-table :data="gridData" border>
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column prop="name" label="品牌名称" align="center"></el-table-column>
          <el-table-column prop="first_co_at" label="首次合作" align="center" width="200px">
            <template slot-scope="{row}">
              <span>{{$utils.parseTime(row.first_co_at,'{y}年{m}月{d}日')}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column prop="is_new" label="是否新合作" align="center">-->
<!--          </el-table-column>-->
          <el-table-column prop="is_famous" label="大牌标签" align="center" width="200px">
            <template slot-scope="{row}">
              <span v-if="row.is_famous ==='Y'" style="color: #ff3176">是</span>
              <span v-else-if="row.is_famous ==='N'">否</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-drawer :title="cbcForm.drawerTitle" :visible.sync="cbcForm.drawer" v-loading="cbcForm.loading" :direction="cbcForm.direction" size="50%" :modal="false" append-to-body>
      <template slot="title">
        <span style="font-size: 18px;font-weight: bold">{{cbcForm.drawerTitle}}</span>
      </template>
      <div id="draw-chart" style="width: 100%;height: 300px" />
      <div class="default-table" style="padding: 10px">
        <el-table :data="cbcForm.gridData" border>
          <el-table-column type="index" label="序号" width="55" align="center" />
          <el-table-column prop="name" label="客户" align="center" />
          <el-table-column prop="order_money" label="金额" align="center" width="200px">
            <template v-slot="{row:{order_money}}">
              <span class="money">{{ order_money|numberFormatW }}</span>
            </template>
          </el-table-column>
          <el-table-column label="占比" align="center">
            <template v-slot="{row:{percent}}">
              <span>{{ percent !== null ? percent + ' %' : '/' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {getDashboardBrandCombinesYear, getDashboardCombineBrandItem, getDashboardCombineBrandList} from "@/api/dashboard";
import moment from "moment";
import {exportToExcel} from "@/utils/export/el-table-export";
import * as echarts from 'echarts';

export default {
  name: "SummaryBrandCombineYear",
  inject: ['condition'],
  data() {
    return {
      loading: false,
      queryOrder: '',
      queryProp: '',
      data: [],
      brandRealCount: 0,
      date_s: null,
      date_e: null,
      gridData: [],
      drawer: false,
      drawerTitle: '品牌',
      direction: 'rtl',
      cbcForm: {
        loading: false,
        drawer: false,
        drawerTitle: '品牌',
        direction: 'rtl',
        sumMoney: 0,
        gridData: [],
      }
    }
  },
  computed: {
    date_s_label() {
      const date_s = this.date_s.split('-')
      return `${date_s[0]}年`
    },
    date_e_label() {
      const date_e = this.date_e.split('-')
      return `${date_e[0]}年`
    },
  },
  created() {
    this.getData()
  },
  watch: {
    condition: {
      handler: function () {
        this.date_e = `${this.condition.year}-${this.condition.month}`
        this.date_s = moment(this.date_e, "YYYY-MM").subtract(1, 'years').format('YYYY-MM')
        this.getData()
      },
      deep: true
    },
    date_s() {
      this.getData()
    },
    date_e() {
      this.getData()
    }
  },
  methods: {
    handelEx: function () {
      exportToExcel('#brand-combine-year', '品牌集团年度统计')
      this.$message.success('导出成功')
    },
    setDate: function () {
      this.date_e = this.date_e || `${this.condition.year}-${this.condition.month}`
      this.date_s = this.date_s || moment(this.date_e, "YYYY-MM").subtract(1, 'years').format('YYYY-MM')
    },
    // 处理搜索条件
    handleSearchCondition() {
      let params = {...{}, ...this.condition}
      params = {...params}
      if (new Date(this.date_e).getTime() < new Date(this.date_s).getTime()) {
        const date_e_old = this.date_e
        const date_s_old = this.date_s
        this.date_s = date_e_old
        this.date_e = date_s_old
      }

      const date_e = this.date_e.split('-')
      const date_s = this.date_s.split('-')

      params.after = {year: date_e[0]}
      params.before = {year: date_s[0]}
      return params
    },
    getData() {
      this.setDate()
      this.loading = true;
      this.data = [];
      const searchCondition = this.handleSearchCondition()
      getDashboardBrandCombinesYear(searchCondition).then(res => {
        this.loading = false;
        this.data = res.model || [];
      })
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['money_before', 'money_after'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "money_before":
            case "money_after":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
          }
        }
      });
      return sums
    },
    getBrands(row) {
      //获取集团的品牌列表
      this.$notify.success(`${row.combine_name}`)
      this.drawerTitle = `归于【${row.combine_name}】的品牌`
      this.gridData = []
      getDashboardCombineBrandList({combine_id: row.combine_id}).then(res => {
        let data = res.model || {};
        this.gridData = data.list || []
        this.drawer = true
      })
    },
    getBrandsItem(row, date_str) {
      // 日期切割
      const date_arr = date_str.split('-')
      //获取集团的品牌列表
      // this.$notify.success(`${row.combine_name}`)
      this.cbcForm.drawerTitle = `归于【${row.combine_name}】【${date_arr[0]}年】的客户`
      this.cbcForm.gridData = []
      this.cbcForm.drawer = true
      this.cbcForm.loading = true
      getDashboardCombineBrandItem({combine_id: row.combine_id, ym: date_str, date_type: 'year'}).then(res => {
        this.cbcForm.loading = false
        let data = res.model || {};
        this.cbcForm.gridData = data.list || []
        this.cbcForm.sumMoney = data.sumMoney || 0
        this.drawChart(this.cbcForm.gridData)
      })
    },
    drawChart(data) {
      const option = {
        padding: ['10%'],
        series: [
          {
            radius: '50%',
            height: '100%',
            center: ['50%', '50%'],
            type: 'pie',
            data: data
          }
        ]
      }
      let myChart = echarts.init(document.getElementById('draw-chart'))
      myChart.setOption(option);
    }
  }
}

</script>
<style lang="scss">
.brand-combine-year-container {
  .el-input--mini .el-input__inner {
    height: 20px !important;
    line-height: 20px !important;
  }

  .el-input--mini .el-input__icon {
    line-height: 20px !important;
  }
}
</style>
